module.exports = __webpack_public_path__ + "static/img/1.647d807.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listen-report/1.png
// module id = 02/V
// module chunks = 216